






































import { Component, Vue } from 'vue-property-decorator'
import { Dashboard } from '@/api/model/dashboard'
import { DashboardAPI } from '@/api/backend-client'
import DashboardBlock from '@/views/Reports/Overview/DashboardBlock.vue'

@Component({
    components: {
        DashboardBlock,
    },
})
export default class Overview extends Vue {
    dashboards: Dashboard[] = []
    loading: boolean = false

    async mounted(): Promise<void> {
        await this.loadDashboards()
    }

    async loadDashboards(): Promise<void> {
        this.loading = true
        this.dashboards = await DashboardAPI.getAll()
        this.loading = false

        if (this.filteredDashboards.length === 1) {
            await this.$router.push({
                name: 'report',
                params: {
                    dashboardId: this.filteredDashboards[0].id,
                },
            })
        }
    }

    get directions(): string[] {
        return [null, 'in', 'out']
    }

    get filteredDirections(): string[] {
        return this.directions.filter(direction => this.categoriesForDirection(direction).length > 0)
    }

    dashboardsForDirection(direction: string|null): Dashboard[] {
        return this.filteredDashboards.filter(dashboard => dashboard.direction === direction)
    }

    categoriesForDirection(direction: string = null): string[] {
        return [...new Set(this.dashboardsForDirection(direction).map(dashboard => dashboard.category))]
    }

    dashboardsForCategory(direction: string|null, category: string|null): Dashboard[] {
        return this.dashboardsForDirection(direction).filter(dashboard => dashboard.category === category)
    }

    get filteredDashboards(): Dashboard[] {
        return this.dashboards.filter(dashboard => {
            // Check if there is an explicit permission set for this dashboard
            const permission = this.$currentUser.dashboardPermissions.find(v => v.dashboard === dashboard.id)
            if (permission && permission.permission !== null) {
                return permission.permission
            }

            // Otherwise check role
            return this.$currentUser.isBranchManager
        })
    }
}
